import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customerSelect", "taskSelect"]

  connect() {
    // Beim Laden prüfen, ob bereits ein Kunde ausgewählt ist (z.B. nach Validierungsfehler oder beim Edit)
    if (this.customerSelectTarget.value) {
      this.loadTasks()
    }
  }

  loadTasks() {
    const customerId = this.customerSelectTarget.value
    const taskSelect = this.taskSelectTarget

    // Wir merken uns die aktuell gewählte Task-ID, bevor wir die Liste neu laden
    const selectedTaskId = taskSelect.dataset.selectedId || taskSelect.value

    if (!customerId) {
      taskSelect.innerHTML = '<option value="">Zuerst Kunde wählen</option>'
      taskSelect.disabled = true
      return
    }

    fetch(`/customers/${customerId}/tasks_data.json`, {
      headers: { "Accept": "application/json" }
    })
      .then(response => {
        if (!response.ok) throw new Error("Network response was not ok")
        return response.json()
      })
      .then(data => {
        taskSelect.innerHTML = '<option value="">Aufgabe wählen...</option>'
        taskSelect.disabled = false

        data.forEach(task => {
          const option = document.createElement("option")
          option.value = task.id
          option.textContent = task.jobtitle

          // Falls eine ID vorlag (z.B. vom Server), diese wieder selektieren
          if (selectedTaskId && task.id.toString() === selectedTaskId.toString()) {
            option.selected = true
          }

          taskSelect.appendChild(option)
        })
      })
      .catch(error => {
        console.error("Error loading tasks:", error)
        taskSelect.innerHTML = '<option value="">Fehler beim Laden</option>'
      })
  }
}